import React from 'react';
import StampDutyQuestionContent from '../components/StampDutyQuestionContent';
import { Layout } from '../layout';

const StampDutyQuestionPage = () => (
  <Layout>
    <StampDutyQuestionContent />
  </Layout>
);

export default StampDutyQuestionPage;
